import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { baseUrl, customHeaders } from './../../../../../Containers/Config/index';
import { CREATE_SURGE_EVENT, CREATE_SURGE_EVENT_SUCCESS, CREATE_SURGE_EVENT_ERROR } from './../../../actionType';
import apiCall from '../../../apiCall';
import { Constant } from '../../../../../Containers/Helpers/constant';
import cogoToast from 'cogo-toast';

function* createEvent({ payload }) {
  try {
    const response = yield call(apiCall, {
      url: `${baseUrl}/admin/event-rules`,
      method: 'POST',
      headers: {
        Authorization: Constant?.CLIENT_TOKEN,
        ...customHeaders,
      },
      data: payload?.data,
    });

    if (response.status === 200) {
      // cogoToast.success(`${response?.data?.message}`)
      cogoToast.success(`Event created successfully!`);
      yield put({
        type: CREATE_SURGE_EVENT_SUCCESS,
        payload: response?.data,
      });
    } else {
      cogoToast.error(response?.response?.data?.message);
      // yield put({
      //     type: CREATE_SURGE_EVENT_ERROR,
      //     payload: response?.data?.message,
      // })
    }
  } catch (error) {
    yield put({ type: CREATE_SURGE_EVENT_ERROR, payload: error });
  }
}

export function* watchCreateEventSaga() {
  yield takeEvery(CREATE_SURGE_EVENT, createEvent);
}

function* createEventSaga() {
  yield all([fork(watchCreateEventSaga)]);
}

export default createEventSaga;
